<ng-container [formGroup]="metadataFormGroup">
  <div class="row row-cols-md-2 row-cols-sm-1 mb-3">
    <div class="col">
      <label i18n>Le client est</label>
      <select class="form-control" formControlName="entityType">
        <option *ngFor="let value of entityTypeValues" [ngValue]="value">
          {{ getEntityTypeLabel(value) }}
        </option>
      </select>
    </div>
    <div class="col">
      <label i18n>Type de construction</label>
      <select class="form-control" formControlName="constructionType">
        <option *ngFor="let value of constructionTypeValues" [ngValue]="value">
          {{ getConstructionTypeLabel(value) }}
        </option>
      </select>
    </div>
  </div>
  <div
    class="row my-3"
    *ngIf="metadataFormGroup.value.constructionType === ConstructionType.OTHER"
  >
    <label i18n>Description</label>
    <input
      type="text"
      formControlName="constructionTypeInfo"
      class="form-control"
    />
  </div>
  <div class="form-subtitle flex-basis-100 mb-16 text-16" i18n>
    Adresse du projet de construction
  </div>
  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Numéro du cadastre</label>
      <input
        type="text"
        class="form-control"
        formControlName="cadastralNumber"
      />
    </div>
    <div class="col">
      <label i18n>Code postal</label>
      <input type="text" class="form-control" formControlName="postalCode" />
    </div>
  </div>
  <div class="row my-3">
    <div class="col">
      <label i18n>Adresse</label>
      <input type="text" class="form-control" formControlName="address" />
    </div>
  </div>
  <div class="row row-cols-md-2 row-cols-sm-1">
    <div class="col">
      <label i18n>Début des travaux</label>
      <input
        type="date"
        class="form-control"
        formControlName="constructionStartDate"
      />
    </div>
    <div class="col">
      <label i18n>Fin des travaux</label>
      <input
        type="date"
        class="form-control"
        formControlName="constructionEndDate"
      />
    </div>
  </div>
  <div class="form-subtitle flex-basis-100 mb-16 text-16" i18n>
    Travaux en cours
  </div>
  <div class="row my-3">
    <div class="col">
      <label i18n
        >Les travaux sont-ils réceptionnés en une fois ou par étape ?</label
      >
      <div class="form-check">
        <input
          type="radio"
          name="gradualConstruction"
          id="gradualConstructionFalse"
          [value]="false"
          formControlName="gradualConstruction"
        />
        <label class="form-check-label" for="gradualConstructionFalse" i18n>
          En une fois
        </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="gradualConstruction"
          id="gradualConstructionTrue"
          [value]="true"
          formControlName="gradualConstruction"
        />
        <label class="form-check-label" for="gradualConstructionTrue" i18n>
          En étapes
        </label>
      </div>
    </div>
  </div>
  <div class="row my-3">
    <div class="col">
      <label i18n>Les travaux ont-ils déjà commencé ?</label>
      <div class="form-check">
        <input
          type="radio"
          name="constructionStarted"
          id="constructionStartedFalse"
          [value]="false"
          formControlName="constructionStarted"
        />
        <label class="form-check-label" for="constructionStartedFalse" i18n>
          Non
        </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="constructionStarted"
          id="constructionStartedTrue"
          [value]="true"
          formControlName="constructionStarted"
        />
        <label class="form-check-label" for="constructionStartedTrue" i18n>
          Oui
        </label>
      </div>
    </div>
  </div>
  <div class="row my-3">
    <div class="col">
      <label i18n>Date de début de l'assurance</label>
      <input
        type="date"
        class="form-control"
        formControlName="insuranceStartDate"
      />
    </div>
  </div>

  <ng-container formGroupName="architect">
    <div class="form-subtitle flex-basis-100 mb-16 mt-16 text-16" i18n>
      Architecte
    </div>
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Nom complet</label>
        <input type="text" class="form-control" formControlName="fullName" />
      </div>
      <div class="col">
        <label i18n>Email</label>
        <input type="text" class="form-control" formControlName="email" />
      </div>
    </div>
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Numéro de téléphone</label>
        <input type="text" class="form-control" formControlName="phoneNumber" />
      </div>
      <div class="col">
        <label i18n>Adresse</label>
        <input type="text" class="form-control" formControlName="address" />
      </div>
    </div>
  </ng-container>
  <ng-container formGroupName="civilEngineer">
    <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-16" i18n>
      Ingénieur civil
    </div>
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Nom complet</label>
        <input type="text" class="form-control" formControlName="fullName" />
      </div>
      <div class="col">
        <label i18n>Email</label>
        <input type="text" class="form-control" formControlName="email" />
      </div>
    </div>
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Numéro de téléphone</label>
        <input type="text" class="form-control" formControlName="phoneNumber" />
      </div>
      <div class="col">
        <label i18n>Adresse</label>
        <input type="text" class="form-control" formControlName="address" />
      </div>
    </div>
  </ng-container>
  <ng-container formGroupName="projectOwner">
    <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-16" i18n>
      Maître d'ouvrage
    </div>
    <div class="row my-3">
      <div class="col">
        <label i18n>Est...</label>
        <select class="form-control" formControlName="type">
          <option *ngFor="let value of projectOwnerTypes" [ngValue]="value">
            {{ getProjectOwnerTypeLabel(value) }}
          </option>
        </select>
      </div>
    </div>
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Nom complet</label>
        <input type="text" class="form-control" formControlName="fullName" />
      </div>
      <div class="col">
        <label i18n>Email</label>
        <input type="text" class="form-control" formControlName="email" />
      </div>
    </div>
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Numéro de téléphone</label>
        <input type="text" class="form-control" formControlName="phoneNumber" />
      </div>
      <div class="col">
        <label i18n>Adresse</label>
        <input type="text" class="form-control" formControlName="address" />
      </div>
    </div>
  </ng-container>
  <div class="form-subtitle flex-basis-100 mb-16 text-16" i18n>Couvertures</div>
  <div class="row my-3">
    <label>Assurance travaux de construction ?</label>
    <div class="form-check">
      <input
        type="radio"
        name="constructionWorkInsuranceWanted"
        id="constructionWorkInsuranceWantedFalse"
        [value]="false"
        formControlName="constructionWorkInsuranceWanted"
      />
      <label
        class="form-check-label"
        for="constructionWorkInsuranceWantedFalse"
        i18n
      >
        Non
      </label>
    </div>
    <div class="form-check">
      <input
        type="radio"
        name="constructionWorkInsuranceWanted"
        id="constructionWorkInsuranceWantedTrue"
        [value]="true"
        formControlName="constructionWorkInsuranceWanted"
      />
      <label
        class="form-check-label"
        for="constructionWorkInsuranceWantedTrue"
        i18n
      >
        Oui
      </label>
    </div>
  </div>
  <div class="row my-3">
    <label
      >Dans les cantons sans établissements cantonaux d'assurance: les risques
      Incendie/événements naturels doivent-ils être assurés ?</label
    >
    <div class="form-check">
      <input
        type="radio"
        name="fireNaturalDisasterInsurance"
        id="fireNaturalDisasterInsuranceFalse"
        [value]="false"
        formControlName="fireNaturalDisasterInsurance"
      />
      <label
        class="form-check-label"
        for="fireNaturalDisasterInsuranceFalse"
        i18n
      >
        Non
      </label>
    </div>
    <div class="form-check">
      <input
        type="radio"
        name="fireNaturalDisasterInsurance"
        id="fireNaturalDisasterInsuranceTrue"
        [value]="true"
        formControlName="fireNaturalDisasterInsurance"
      />
      <label
        class="form-check-label"
        for="fireNaturalDisasterInsuranceTrue"
        i18n
      >
        Oui
      </label>
    </div>
  </div>
  <div class="row my-3">
    <label
      >Assurance responsabilité civile constructeur du maître d'ouvrage ?</label
    >
    <div class="form-check">
      <input
        type="radio"
        name="projectOwnerCivilResponsibility"
        id="projectOwnerCivilResponsibilityFalse"
        [value]="false"
        formControlName="projectOwnerCivilResponsibility"
      />
      <label
        class="form-check-label"
        for="projectOwnerCivilResponsibilityFalse"
        i18n
      >
        Non
      </label>
    </div>
    <div class="form-check">
      <input
        type="radio"
        name="projectOwnerCivilResponsibility"
        id="projectOwnerCivilResponsibilityTrue"
        [value]="true"
        formControlName="projectOwnerCivilResponsibility"
      />
      <label
        class="form-check-label"
        for="projectOwnerCivilResponsibilityTrue"
        i18n
      >
        Oui
      </label>
    </div>
  </div>
  <div class="row my-3">
    <label
      >Le propriétaire participe-t-il activement à des travaux d'excavation ou à
      des travaux sur des structures porteuses sans assurance responsabilité
      adéquate ?</label
    >
    <div class="form-check">
      <input
        type="radio"
        name="ownerWithoutInsurance"
        id="ownerWithoutInsuranceFalse"
        [value]="false"
        formControlName="ownerWithoutInsurance"
      />
      <label class="form-check-label" for="ownerWithoutInsuranceFalse" i18n>
        Non
      </label>
    </div>
    <div class="form-check">
      <input
        type="radio"
        name="ownerWithoutInsurance"
        id="ownerWithoutInsuranceTrue"
        [value]="true"
        formControlName="ownerWithoutInsurance"
      />
      <label class="form-check-label" for="ownerWithoutInsuranceTrue" i18n>
        Oui
      </label>
    </div>
  </div>
  <div class="row my-3">
    <label
      >Le pouvoir adjudicateur est-il propriétaire des travaux sur le terrain ou
      à proximité immédiate des travaux réalisés ?</label
    >
    <div class="form-check">
      <input
        type="radio"
        name="nearAdjuvant"
        id="nearAdjuvantFalse"
        [value]="false"
        formControlName="nearAdjuvant"
      />
      <label class="form-check-label" for="nearAdjuvantFalse" i18n> Non </label>
    </div>
    <div class="form-check">
      <input
        type="radio"
        name="nearAdjuvant"
        id="nearAdjuvantTrue"
        [value]="true"
        formControlName="nearAdjuvant"
      />
      <label class="form-check-label" for="nearAdjuvantTrue" i18n> Oui </label>
    </div>
  </div>
  <div class="form-subtitle flex-basis-100 mb-16 text-16" i18n>
    Questions relatives aux risques
  </div>
  <div class="row my-3">
    <div class="col">
      <label i18n>Coût total des travaux du projet</label>
      <input
        type="number"
        class="form-control"
        min="0"
        formControlName="totalCost"
      />
    </div>
  </div>
  <div class="row my-3">
    <label
      >S'agit-il d'un projet de génie civil (tunnel, route, passage souterrain,
      remembrement, etc.) ?</label
    >
    <div class="form-check">
      <input
        type="radio"
        name="isCivilEngineering"
        id="isCivilEngineeringFalse"
        [value]="false"
        formControlName="isCivilEngineering"
      />
      <label class="form-check-label" for="isCivilEngineeringFalse" i18n>
        Non
      </label>
    </div>
    <div class="form-check">
      <input
        type="radio"
        name="isCivilEngineering"
        id="isCivilEngineeringTrue"
        [value]="true"
        formControlName="isCivilEngineering"
      />
      <label class="form-check-label" for="isCivilEngineeringTrue" i18n>
        Oui
      </label>
    </div>
  </div>
  <div class="row my-3">
    <div class="col">
      <label i18n
        >Distance à la structure tertiaire la plus proche, existante ou en
        construction</label
      >
      <select class="form-control" formControlName="nearestStructure">
        <option
          *ngFor="let value of nearestStructureDistanceValues"
          [ngValue]="value"
        >
          {{ getNearestStructureDistanceLabel(value) }}
        </option>
      </select>
    </div>
  </div>
  <div class="row my-3">
    <label i18n>
      La démolition de bâtiments entiers ou de parties de bâtiments ou
      d'ouvrages est prévue ?
    </label>
    <div class="form-check">
      <input
        type="radio"
        name="plannedDemolition"
        id="plannedDemolitionFalse"
        [value]="false"
        formControlName="plannedDemolition"
      />
      <label class="form-check-label" for="plannedDemolitionFalse" i18n>
        Non
      </label>
    </div>
    <div class="form-check">
      <input
        type="radio"
        name="plannedDemolition"
        id="plannedDemolitionTrue"
        [value]="true"
        formControlName="plannedDemolition"
      />
      <label class="form-check-label" for="plannedDemolitionTrue" i18n>
        Oui
      </label>
    </div>
  </div>
  <div class="row my-3">
    <div class="col">
      <label i18n>Quelle est la typographie ?</label>
      <select class="form-control" formControlName="topography">
        <option *ngFor="let value of topographyValues" [ngValue]="value">
          {{ getTopographyLabel(value) }}
        </option>
      </select>
    </div>
  </div>
</ng-container>
